import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {StockReplenishmentReportModel} from "./stock-replenishment-report.model";
import {EntityGroupByReportCriteriaComponent} from "../../../reports/common-report-criteria/entity-group-by-report-criteria/entity-group-by-report-criteria.component";

@Component({
    selector: "wbo-stock-replenishment-report",
    templateUrl: "./stock-replenishment-report.component.html",
    providers: [provideReportModel(StockReplenishmentReportModel)]
})
export class StockReplenishmentReportComponent extends AbstractReportPage {
    constructor(public model: StockReplenishmentReportModel) {
        super();
    }

    get showInventoryGroupOption(): boolean {
        return this.model.data.reportType !== EntityGroupByReportCriteriaComponent.INVENTORY_VALUE;
    }
}
